// Fire-and-forget report of a frontend error to the backend, which logs it
// and emails an alert. Runs only in production and never throws.
export default function reportFrontendError({
  errorId,
  message,
  stack,
  componentStack,
  details,
}: {
  errorId?: string;
  message: string;
  stack?: string;
  componentStack?: string;
  details?: string;
}) {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  if (!import.meta.env.PROD || !baseUrl) {
    return;
  }

  const token = localStorage.getItem('access_token');

  try {
    fetch(`${baseUrl}/api/frontend-errors`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({
        error_id: errorId,
        message,
        stack,
        component_stack: componentStack,
        details,
        url: window.location.href,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Never let reporting surface a second error over the original one.
  }
}
